import { Badge, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { TextWithCopy } from '~/packages/common-frontend/components/TextWithCopy';

/**
 * Compact, copyable artifact-document id. An optional muted label and version
 * badge precede a truncated, de-emphasized id (full id copies on click).
 * Shared by the status bar's "Latest committed" chip and View mode's selected
 * document chip so the copyable-id presentation lives in exactly one place.
 */
export const ArtifactIdChip = ({
  id,
  label,
  version,
  copyLabel,
}: {
  id: string | null | undefined;
  label?: string;
  version?: number | null;
  copyLabel?: string;
}): React.ReactElement | null => {
  if (!id) {
    return null;
  }

  return (
    <Flex align="center" gap="1.5">
      {label && (
        <Text fontSize="xs" color="gray.500" whiteSpace="nowrap">
          {label}
        </Text>
      )}
      {version !== null && version !== undefined && (
        <Badge variant="subtle" colorScheme="gray">
          v{version}
        </Badge>
      )}
      <TextWithCopy
        label={copyLabel ?? 'Copy artifact document ID'}
        styleProps={{
          fontSize: 'xs',
          color: 'gray.400',
          fontFamily: 'mono',
          maxWidth: '11ch',
          isTruncated: true,
        }}
      >
        {id}
      </TextWithCopy>
    </Flex>
  );
};
